module.exports = __webpack_public_path__ + "static/media/akzo-nobel.25485bd6.svg";